import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  getDataCountryQuery,
  getDataTvaRegimeQuery,
  getDataPaymentConditionQuery,
  getTTVquery,
  getAllBoDocsQuery,
  getBoDocQuery,
  getBoFileQuery,
  editBoDocQuery,
  editBoFileQuery,
  deleteDocQuery,
  postDocQuery,
} from "./queries";

const SettingsContext = createContext({});

export const useSettingsContext = () => useContext(SettingsContext);

export const SettingsProvider = ({ ...props }) => {
  const [dataCountry, setDataCountry] = useState([]);
  const [dataTvaRegime, setDataTvaRegime] = useState([]);
  const [dataPaymentCondition, setDataPaymentCondition] = useState([]);
  const [dataTTV, setDataTTV] = useState([]);
  const [BODocList, setBODocList] = useState([]);
  const [BODoc, setBODoc] = useState({});
  const [BOFile, setBOFile] = useState({});

  const postBoDoc = useCallback(async (payload) => {
    try {
      await postDocQuery(payload);
      const updatedBODocs = await getAllBoDocs();
      return setBODocList(updatedBODocs);
    } catch (e) {
      console.error("postBoDoc", e);
      throw e;
    }
  }, []);

  const getAllBoDocs = useCallback(async () => {
    try {
      const updatedBODocs = await getAllBoDocsQuery();
      return setBODocList(updatedBODocs);
    } catch (e) {
      console.error("getAllBoDocs", e);
      throw e;
    }
  }, []);

  const getBoDoc = useCallback(async (id) => {
    try {
      const BODoc = await getBoDocQuery(id);
      return setBODoc(BODoc);
    } catch (e) {
      console.error("getBoDoc", e);
      throw e;
    }
  }, []);

  const getBoFile = useCallback(async (id) => {
    try {
      const BOFile = await getBoFileQuery(id);
      return setBOFile(BOFile);
    } catch (e) {
      console.error("getBoFile", e);
      throw e;
    }
  }, []);

  const editBoDoc = useCallback(async (id, payload) => {
    try {
      await editBoDocQuery(id, payload);
      const updatedBODocs = await getAllBoDocs();
      return setBODocList(updatedBODocs);
    } catch (e) {
      console.error("editBoDoc", e);
      throw e;
    }
  }, []);

  const editBoFile = useCallback(async (id, payload) => {
    try {
      await editBoFileQuery(id, payload);
      const updatedBODocs = await getAllBoDocs();
      return setBODocList(updatedBODocs);
    } catch (e) {
      console.error("editBoFile", e);
      throw e;
    }
  }, []);

  const deleteDoc = useCallback(async (id) => {
    try {
      await deleteDocQuery(id);
      const updatedBODocs = await getAllBoDocs();
      return setBODocList(updatedBODocs);
    } catch (e) {
      console.error("deleteDoc", e);
      throw e;
    }
  }, []);

  const getDataTTV = useCallback(async () => {
    try {
      if (dataTTV.length === 0) {
        setDataTTV(await getTTVquery());
      }
    } catch (e) {
      console.error("getDataTTV", e);
      throw e;
    }
  }, [setDataTTV]);

  const getDataCountry = useCallback(async () => {
    try {
      if (dataCountry.length === 0) {
        setDataCountry(await getDataCountryQuery());
      }
    } catch (e) {
      console.error("getDataCountry", e);
      throw e;
    }
  }, [dataCountry]);

  const getDataTvaRegime = useCallback(async () => {
    try {
      if (dataTvaRegime.length === 0) {
        setDataTvaRegime(await getDataTvaRegimeQuery());
      }
    } catch (e) {
      console.error("getDataTvaRegime", e);
      throw e;
    }
  }, [setDataTvaRegime]);

  const getDataPaymentCondition = useCallback(async () => {
    try {
      if (dataPaymentCondition.length === 0) {
        setDataPaymentCondition(await getDataPaymentConditionQuery());
      }
    } catch (e) {
      console.error("getDataPaymentCondition", e);
      throw e;
    }
  }, [setDataPaymentCondition]);

  const values = useMemo(
    () => ({
      dataCountry,
      getDataCountry,
      dataTvaRegime,
      getDataTvaRegime,
      dataPaymentCondition,
      getDataPaymentCondition,
      getDataTTV,
      dataTTV,
      postBoDoc,
      BODoc,
      BOFile,
      BODocList,
      getAllBoDocs,
      getBoDoc,
      getBoFile,
      editBoDoc,
      editBoFile,
      deleteDoc,
    }),
    [
      BODoc,
      BOFile,
      BODocList,
      dataCountry,
      getDataCountry,
      dataTvaRegime,
      getDataTvaRegime,
      dataPaymentCondition,
      getDataPaymentCondition,
      getDataTTV,
      dataTTV,
    ]
  );
  return <SettingsContext.Provider value={values} {...props} />;
};
